import type { CameraFailure } from "../../core/services/card-camera";

/** The scanner's words, as iOS says them (`AdminScanModeView`, `AdminCaptureViewModel`), and what a browser adds. */

export const FRONT_PROMPT = "Place card within the frame to capture it";
export const BACK_PROMPT = "Now capture the back of the card";
export const TORCH_IN_APP = "The torch, for a dim counter, is in the HobbyScan app.";
export const LIVE_CAMERA_IN_APP = "Scanning card after card with the live camera is in the HobbyScan app.";

export const CAMERA_SENTENCES: Readonly<Record<CameraFailure, string>> = {
  denied: "Camera access is off for this site. Allow it in your browser's settings to scan here.",
  none: "This device has no camera available.",
  busy: "Another app is using the camera. Close it and try again.",
  insecure: "The live camera needs a secure (https) page.",
  unsupported: "This browser has no live camera.",
  onAir: "The camera is on air in Live.",
  other: "The camera did not start. Try again.",
};

/** Where the scanner lands, as iOS: the customer's page when it scanned for one, else Inventory › Review. */
export function scannerLanding(customerId: string | null): string {
  return customerId === null ? "/drafts" : `/customer-scans?customer=${encodeURIComponent(customerId)}`;
}

/**
 * Done and ✕: back, when the scanner was opened from the page it lands on (`openedFrom`, the opener's router
 * state), else that page in the scanner's place. Either way Back never reopens the camera.
 */
export function scannerExit(customerId: string | null, openedFrom: unknown): { back: true } | { to: string } {
  const landing = scannerLanding(customerId);
  return openedFrom === landing ? { back: true } : { to: landing };
}

export const SHOT_UNREADABLE = "Could not read that photo. Try again.";

export const importUnreadable = (name: string) => `Could not open ${name}. Import a JPEG, PNG or WebP photo.`;
